import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useRouteMatch, useLocation } from "react-router-dom";
import axios from "axios";
import { serverUrl } from "../../components/Helpers/Config";
import Sidebar from "../../components/Sidebar/Sidebar";
import ButtonBlue from "../../components/Button/ButtonBlue";
import "../../styles/journal.styles.scss";
import * as AiIcons from "react-icons/ai";
import SearchBar from "../../components/Searchbar";
import { staticFiles } from "../../components/Helpers/Static";
import noprofile from "../../common/images-new/no-profile-pic.png";
import ProfileCard from "./ProfileCard";
import Button from "../../components/Button/Button";
import ButtonCommon from "../../components/Button/ButtonCommon";
// import { Loading } from '../../components/Helpers/Common';
import Swal from "sweetalert2";
import { getUrl } from "../../components/Helpers/Config";
import { tokenAuthorize } from "../../components/Helpers/Common";
import { makeStyles } from "@mui/styles";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import Tooltip from "@mui/material/Tooltip";
import { MenuItemCard, MenuItemDiv, ButtonCommonTopNew } from "../Theme";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { getCommunityGroups } from "../../redux/actions/communityGroups";
import Loading from "../../components/Button/Loading";
import Loader, {
  CommunityLoader,
  CommunityLoadMoreLoader,
} from "../../components/Button/Loader";
const noProfile = noprofile;

function ShowcaseGallery(props) {
  const SIDEBARDATA = [
    {
      title: "Active Groups",
      iconClosed: <AiIcons.AiFillCaretRight />,
      iconOpened: <AiIcons.AiFillCaretDown />,
      item: [],
      open: true,
    },
    {
      title: "Archived Groups",
      iconClosed: <AiIcons.AiFillCaretRight />,
      iconOpened: <AiIcons.AiFillCaretDown />,
      item: [],
      open: false,
    },
  ];
  const { path } = useRouteMatch();
  const dispatch = useDispatch();
  const history = useHistory();
  const [profileSelection, setProfileSelection] = useState([]);
  const [filterOptions, setFilterOptions] = useState(SIDEBARDATA);
  const [searchField, setSearchField] = useState("");
  const [sortBy, setsortBy] = useState("last_update");
  const [order, setOrder] = useState("asc");
  const [offset, setOffset] = useState(0);
  const [isLoading, setisLoading] = useState(false);
  const [screenLoading, setScreenLoading] = useState(false);
  const [Profile, setProfile] = useState([]);
  const [len, setLen] = useState(0);
  //nithish added
  const [selectedOption, setSelectedOption] = useState({
    type: 0,
    value: "",
  });
  const [loadMoreLoader, setLoadMoreLoader] = useState(false);
  const isDefaultTheme = useSelector((state) => state.auth.isDefaultTheme);
  const userTheme = useSelector((state) => state.auth.theme);
  const [isStudent, setisStudent] = useState(false);
  const [isTutor, setisTutor] = useState(false);
  const userProfile = useSelector((state) => state.auth.user);
  const groups = useSelector((state) => state.communityGroups.groups);

  const useStyles = makeStyles((theme) => ({
    customMenu: {
      backgroundColor:
        isDefaultTheme == false && userTheme
          ? `${userTheme?.color3} !important`
          : "white !important",
      width: "200 !important;",
    },
    nestedMenu: {
      pointerEvents: "none",
      paddingRight: 20, // add right space
      minWidth: 180,
    },
    nestedContent: {
      pointerEvents: "auto",
    },
  }));
  //side bar data

  useEffect(() => {
    setScreenLoading(true);
    axios
      .get(serverUrl.ShowcaseGalleryGroup)
      .then((res) => {
        if (res.status === 200) {
          // let showcase=[{group_id:-1,group_name:"All"}];
          let showcase = [];
          let i = 0;
          let archived = res.data
            .filter((val) =>
              groups?.some(
                (group) =>
                  group.id === val.group_id &&
                  ((!group.is_parent && group.is_community_archived === true) ||
                    (group.is_parent && group.is_parent_archived === true))
              )
            )
            .sort((a, b) => a.group_name.localeCompare(b.group_name));

          let active = res.data
            .filter((val) =>
              groups?.some(
                (group) =>
                  group.id === val.group_id &&
                  ((!group.is_parent &&
                    group.is_community_archived === false) ||
                    (group.is_parent && group.is_parent_archived === false))
              )
            )
            .sort((a, b) => a.group_name.localeCompare(b.group_name));
          setSelectedOption({
            type: active[0] ? 0 : archived[0] ? 1 : "",
            value: active[0]
              ? active[0].group_id
              : archived[0]
              ? archived[0].group_id
              : "",
          });
          //setFilterOptions(showcase);
          let currentFilterOptions = [...filterOptions];
          currentFilterOptions[0].item = active
            .map((item, index) => ({
              id: item.group_id,
              value: item.group_name,
              count: item.count ? parseInt(item.count) : 0,
            }))

          currentFilterOptions[1].item = archived
            .map((item, index) => ({
              id: item.group_id,
              value: item.group_name,
              count: item.count ? parseInt(item.count) : 0,
            }))
          setFilterOptions(currentFilterOptions);
        }
      })
      .catch((err) => {
        console.log(err);
        setisLoading(false);
        setScreenLoading(false);
      });
  }, [groups]);

  useEffect(() => {
    if (isTutor || isStudent) {
      dispatch(getCommunityGroups(isTutor, isStudent));
    }
  }, [isTutor, isStudent]);

  useEffect(() => {
    if (userProfile.role === "MANAGER") {
      setisTutor(true);
      setisStudent(false);
    }
    if (userProfile.role === "MEMBER") {
      setisTutor(false);
      setisStudent(true);
    }
  }, [userProfile]);
  //Card Rendering Process
  useEffect(() => {
    if (loadMoreLoader != true) {
      setisLoading(true);
    }
    if (selectedOption?.value !== "") {
      axios
        .get(
          serverUrl.ShowcaseGallery +
            `?group_id=${
              selectedOption?.value
            }&sort_by=${sortBy}&sort_order=${order}&offset=${offset}&limit=${10}`
        )
        .then((res) => {
          if (res.status == 200) {
            let data = [...profileSelection];
            let userid = data.map((val) => val.user_id);
            let newData = res.data;
            newData.forEach((value) => {
              let ids = value.user_id;
              if (!userid.includes(ids)) {
                data.push(value);
              }
            });
            setProfileSelection(filterProfile(data));
            setProfile(filterProfile(data));
            setLen(newData.length);
            setisLoading(false);
            setLoadMoreLoader(false);
            setScreenLoading(false);
          } else {
            setisLoading(false);
            setLoadMoreLoader(false);
            setScreenLoading(false);
          }
        })
        .catch((err) => {
          setisLoading(false);
          setLoadMoreLoader(false);
          console.log(err);
        });
    }
  }, [selectedOption, offset]);

  //Filter Process
  useEffect(() => {
    setisLoading(true);
    if (selectedOption?.value !== "") {
      axios
        .get(
          serverUrl.ShowcaseGallery +
            `?group_id=${
              selectedOption?.value
            }&sort_by=${sortBy}&sort_order=${order}&offset=${0}&limit=${10}`
        )
        .then((res) => {
          if (res.status == 200) {
            let data = [...res.data];
            setProfileSelection(filterProfile(data));
            setProfile(filterProfile(data));
            setOffset(0);
            setLen(data.length);
            setisLoading(false);
          } else {
            setisLoading(false);
          }
        })
        .catch((err) => {
          setisLoading(false);
          console.log(err);
        });
    }
  }, [sortBy, order]);
  // ----------------------------------------------------------------------------------------------------------------------------

  //filter Process
  function filterProfile(selectedProfile) {
    const filteredList = selectedProfile.filter((profile) =>
      searchField.length > 0
        ? profile.fullname.toLowerCase().includes(searchField.toLowerCase())
        : profile
    );
    return filteredList;
  }

  // const setFilterValue = (value) => {
  //     if (selectedOption != value) {
  //         setSelectedOption(value)
  //         setSearchField("");
  //         setOffset(0);
  //         setLen(0);
  //         setProfileSelection([]);
  //     }
  // }
  const setFilterValue = (type, value) => {
    setSelectedOption({ type, value });
    setSearchField("");
    setOffset(0);
    setLen(0);
    setProfileSelection([]);
  };

  useEffect(() => {
    if (profileSelection.length !== 0 && searchField.length > 0) {
      setProfileSelection(filterProfile(Profile));
    } else {
      setProfileSelection(Profile);
    }
  }, [searchField]);

  const handleFilter = () => {
    if (profileSelection.length !== 0 && searchField.length > 0) {
      setProfileSelection(filterProfile(Profile));
    } else {
      setProfileSelection(Profile);
    }
  };

  const handleLoadmore = () => {
    setLoadMoreLoader(true);
    setOffset(offset + 10);
  };

  const handleProfilePage = (userGid) => {
    axios
      .get(serverUrl.LoadUser1 + "/" + userGid)
      .then((resp) => {
        if (resp.status === 200) {
          window.open(getUrl("/profile/") + userGid, "_blank");
        } else if (resp.status === 404) {
          Swal.fire({
            title: "Information",
            text: "This user has not created a Digital Portfolio yet",
            icon: "info",
          });
        }
      })
      .catch((err) => {
        if (err?.response?.status === 404) {
          Swal.fire({
            title: "Information",
            text: "This user has not created a Digital Portfolio yet",
            icon: "warning",
          });
        }
        tokenAuthorize(err?.response?.status);
        console.log(err);
      });
  };
  const [submenuAnchor, setSubmenuAnchor] = useState(null);
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const [sortMenu, setSortMenu] = useState(null);

  const handleSubmenuOpen = (event, type) => {
    setSubmenuAnchor(event.currentTarget);
    setActiveSubmenu(type);
  };

  const handleSubmenuClose = () => {
    setSubmenuAnchor(null);
    setActiveSubmenu(null);
  };
  const classes = useStyles();
  const handleSortChanges = (sortBy1, sortOrder) => {
    handleSubmenuClose();
    setSortMenu(null);
    setsortBy(sortBy1);
    setOrder(sortOrder);
  };
  return (
    <>
      {screenLoading ? (
        <CommunityLoader />
      ) : (
        <>
          <div className="flex flex-col md:flex-col lg:flex-row pt-0 mb-8">
            <div className="flex flex-row-reverse lg:flex-col border-right-f1">
              <div className="w-full border-bottom-f1 p-3.5 box-border">
                <SearchBar
                  setSearchField={setSearchField}
                  onClick={handleFilter}
                />
              </div>
              <Sidebar
                data={filterOptions}
                selectedOption={selectedOption}
                setSelectedOption={setFilterValue}
                isShowcaseGallery={true}
              />
            </div>

            <div className="w-full backGroundColor pb-5">
              <div className="flex justify-end cardBackgroundColor p-4 pb-4 mb-4 px-5 items-center">
                <Tooltip title={"Sort"} placement="top" arrow>
                  <ButtonCommonTopNew
                    onClick={(e) => {
                      setSortMenu(e.currentTarget);
                    }}
                    className="cursor-pointer text-xs w-10 h-9 lg:text-sm rounded-lg py-2 flex justify-center items-center font-regular "
                  >
                    <SwapVertIcon
                      style={{ fontSize: "22px" }}
                      className=" blueColor"
                    />
                  </ButtonCommonTopNew>
                </Tooltip>
                <MenuItemCard className="px-0 mx-0 hidden">
                  <Menu
                    id="sort-menu"
                    anchorEl={sortMenu}
                    keepMounted
                    onMouseLeave={handleSubmenuClose}
                    classes={{ paper: classes.customMenu }}
                    open={Boolean(sortMenu)}
                    onClose={() => {
                      setSortMenu(null);
                    }}
                    disableScrollLock={true}
                  >
                    <MenuItemCard>
                      <MenuItem
                        onMouseEnter={(e) => handleSubmenuOpen(e, "name")}
                        onClick={(e) => handleSubmenuOpen(e, "name")}
                        onMouseLeave={handleSubmenuClose}
                        className="flex gap-1.5 px-1"
                      >
                        <div className="flex justify-between w-full blackColor text-sm">
                          Name
                        </div>
                        {activeSubmenu === "name" && (
                          <Menu
                            anchorEl={submenuAnchor}
                            open={Boolean(submenuAnchor)}
                            onClose={handleSubmenuClose}
                            MenuListProps={{
                              sx: {
                                paddingTop: 0,
                                paddingBottom: 0,
                              },
                            }}
                            className={classes.nestedMenu}
                            anchorOrigin={{
                              vertical: "top",
                              horizontal: "left",
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "right",
                            }}
                            disableScrollLock={true}
                          >
                            <MenuItemCard
                              className={classes.nestedContent + " py-1"}
                            >
                              <MenuItem
                                className="flex gap-1.5 px-1 blackColor text-sm"
                                onClick={() => {
                                  handleSortChanges("name", "asc");
                                }}
                              >
                                <span className="text-sm"> Ascending</span>
                              </MenuItem>
                              <MenuItem
                                className="flex gap-1.5 px-1 blackColor text-sm"
                                onClick={() => {
                                  handleSortChanges("name", "desc");
                                }}
                              >
                                <span className="text-sm"> Descending</span>
                              </MenuItem>
                            </MenuItemCard>
                          </Menu>
                        )}
                      </MenuItem>

                      {/* Sort by Last Update */}
                      <MenuItem
                        onMouseEnter={(e) =>
                          handleSubmenuOpen(e, "last_update")
                        }
                        onClick={(e) => handleSubmenuOpen(e, "last_update")}
                        onMouseLeave={handleSubmenuClose}
                        className="flex gap-1.5 px-1"
                      >
                        <div className="flex justify-between w-full blackColor text-sm">
                          Last Update
                        </div>
                        {activeSubmenu === "last_update" && (
                          <Menu
                            anchorEl={submenuAnchor}
                            open={Boolean(submenuAnchor)}
                            onMouseLeave={handleSubmenuClose}
                            className={classes.nestedMenu}
                            MenuListProps={{
                              sx: {
                                paddingTop: 0,
                                paddingBottom: 0,
                              },
                            }}
                            onClose={handleSubmenuClose}
                            anchorOrigin={{
                              vertical: "top",
                              horizontal: "left",
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "right",
                            }}
                            disableScrollLock={true}
                          >
                            <MenuItemCard
                              className={classes.nestedContent + " py-1"}
                            >
                              <MenuItem
                                className="flex gap-1.5 px-1 blackColor "
                                onClick={() => {
                                  handleSubmenuClose();
                                  handleSortChanges("last_update", "asc");
                                }}
                              >
                                <span className="text-sm"> Ascending</span>
                              </MenuItem>
                              <MenuItem
                                className="flex gap-1.5 px-1 blackColor text-sm "
                                onClick={() => {
                                  handleSubmenuClose();
                                  handleSortChanges("last_update", "desc");
                                }}
                              >
                                <span className="text-sm"> Descending</span>
                              </MenuItem>
                            </MenuItemCard>
                          </Menu>
                        )}
                      </MenuItem>

                      {/* Sort by Public Reflection Count */}
                      <MenuItem
                        onMouseEnter={(e) => handleSubmenuOpen(e, "prc")}
                        onClick={(e) => handleSubmenuOpen(e, "prc")}
                        onMouseLeave={handleSubmenuClose}
                        className="flex gap-1.5 px-1"
                      >
                        <div className="flex justify-between w-full blackColor text-sm">
                          Public Reflection Count
                        </div>
                        {activeSubmenu === "prc" && (
                          <Menu
                            anchorEl={submenuAnchor}
                            open={Boolean(submenuAnchor)}
                            onMouseLeave={handleSubmenuClose}
                            className={classes.nestedMenu}
                            MenuListProps={{
                              sx: {
                                paddingTop: 0,
                                paddingBottom: 0,
                              },
                            }}
                            onClose={handleSubmenuClose}
                            anchorOrigin={{
                              vertical: "top",
                              horizontal: "left",
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "right",
                            }}
                            disableScrollLock={true}
                          >
                            <MenuItemCard
                              className={classes.nestedContent + " py-1"}
                            >
                              <MenuItem
                                className="flex gap-1.5 px-1 blackColor "
                                onClick={() => {
                                  handleSubmenuClose();
                                  handleSortChanges("prc", "asc");
                                }}
                              >
                                <span className="text-sm"> Ascending</span>
                              </MenuItem>
                              <MenuItem
                                className="flex gap-1.5 px-1 blackColor text-sm "
                                onClick={() => {
                                  handleSubmenuClose();
                                  handleSortChanges("prc", "desc");
                                }}
                              >
                                <span className="text-sm"> Descending</span>
                              </MenuItem>
                            </MenuItemCard>
                          </Menu>
                        )}
                      </MenuItem>
                    </MenuItemCard>
                  </Menu>
                </MenuItemCard>
              </div>
              {isLoading ? (
                <CommunityLoader />
              ) : (
                <>
                  <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-4 px-5">
                    {profileSelection.map((data, index) => (
                      <ProfileCard
                        key={index}
                        data={data}
                        noProfile={noProfile}
                        handleProfilePage={handleProfilePage}
                      />
                    ))}
                  </div>
                  {len >= 10 && (
                    <div className="grid grid-rows-1 justify-center mt-5">
                      <div className="grid grid-cols-1">
                        {loadMoreLoader && <CommunityLoadMoreLoader />}
                        {!loadMoreLoader && (
                          <ButtonCommonTopNew
                            className="px-5 border p-2 text-sm rounded-lg cursor-pointer"
                            onClick={() => handleLoadmore()}
                          >
                            Load more
                          </ButtonCommonTopNew>
                        )}
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default ShowcaseGallery;
